// SearchTokens — the three dresses of the search grammar (board 17). Every colour is a house token.

.token {
    position: relative;
    display: inline-flex;
    align-items: center;
    flex: none;
    gap: 3px;
    box-sizing: border-box;
    padding: 2px 10px;
    border: 1px solid transparent;
    border-radius: var(--tl-radius-pill);
    font-family: var(--tl-font);
    font-size: 12.5px;
    line-height: 1.3;
    white-space: nowrap;
}

// Yours, applied: filled.
.pill {
    color: var(--tl-accent-ink);
    background: var(--tl-accent);
    border-color: var(--tl-accent);
}

// The system's guess, applied: outlined.
.lean {
    color: var(--tl-accent);
    background: none;
    border-color: var(--tl-accent-line);
}

// Not applied: dashed.
.offered {
    padding: 3px 10px;
    gap: 7px;
    color: var(--tl-muted);
    background: none;
    border: 1px dashed var(--tl-border-offered);
    cursor: pointer;

    &:hover {
        color: var(--tl-text);
    }

    &:focus-visible {
        outline: 1px solid var(--tl-accent);
        outline-offset: 2px;
    }
}

.still {
    cursor: inherit;
}

// In the field one click removes the token: no step between, so it reads as removable on hover and focus.
.removable {
    margin: 0;
    cursor: pointer;

    &:hover {
        filter: brightness(0.88);
    }

    &:focus-visible {
        outline: 1px solid var(--tl-accent);
        outline-offset: 2px;
    }
}

.lean.removable:hover {
    background: var(--tl-halo);
    filter: none;
}

// The keyboard's mark: Backspace once marks the last token, a second press removes it.
.pill[data-marked] {
    box-shadow: 0 0 0 2px var(--tl-accent-line);
}

.lean[data-marked] {
    background: var(--tl-halo);
}

.swatch {
    flex: none;
    width: 11px;
    height: 11px;
    border-radius: var(--tl-radius-pill);
}

// A dark swatch (black, grey, brown) wears a ring so it shows on a dark surface.
.swatchDark {
    box-shadow: 0 0 0 1px var(--tl-border-strong);
}

:global(html[data-wall-surface='sheet']) {
    .offered {
        min-height: 34px;
        padding: 6px 12px;
        font-size: 13px;
    }

    // A tap lands on the whole pill: room above and below within the field's own height.
    .removable {
        padding: 6px 12px;
    }
}
